var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.776 10.7778H4.2032C3.51321 10.7778 3.16822 10.7778 2.90468 10.911C2.67287 11.0282 2.4844 11.2151 2.36628 11.4451C2.232 11.7066 2.232 12.0488 2.232 12.7333V23M18.864 10.7778H22.4368C23.1268 10.7778 23.4718 10.7778 23.7353 10.911C23.9671 11.0282 24.1556 11.2151 24.2737 11.4451C24.408 11.7066 24.408 12.0488 24.408 12.7333V23M18.864 23V4.91111C18.864 3.54209 18.864 2.85759 18.5954 2.33469C18.3592 1.87474 17.9823 1.50079 17.5186 1.26643C16.9916 1 16.3016 1 14.9216 1H11.7184C10.3384 1 9.64844 1 9.12137 1.26643C8.65773 1.50079 8.28079 1.87474 8.04456 2.33469C7.776 2.85759 7.776 3.54209 7.776 4.91111V23M25.64 23H1M12.088 5.88889H14.552M12.088 10.7778H14.552M12.088 15.6667H14.552",
    stroke: "#38CB89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.3cbd148950b26042847a7ee0ad5aada8.svg";
export { ForwardRef as ReactComponent };